import script from "./CampaignsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignsView.vue?vue&type=script&setup=true&lang=js"

import "./CampaignsView.vue?vue&type=style&index=0&id=1133f6b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1133f6b0"]])

export default __exports__